export const WEBMAP_BASELAYER_ID_PREFIX = 'webmap-baselayer';
